import * as React from 'react'

import { cn } from '@/lib/utils'

interface BrandMarkProps extends React.ComponentProps<'div'> {
  size?: 'sm' | 'md' | 'lg'
  wordmark?: boolean
  product?: string
}

const sizeMap: Record<NonNullable<BrandMarkProps['size']>, {
  glyph: string
  text: string
  gap: string
}> = {
  sm: { glyph: 'size-5', text: 'text-sm', gap: 'gap-2' },
  md: { glyph: 'size-7', text: 'text-base', gap: 'gap-2.5' },
  lg: { glyph: 'size-9', text: 'text-lg', gap: 'gap-3' },
}

function BrandMark({
  size = 'md',
  wordmark = true,
  product = 'Bosun',
  className,
  ...props
}: BrandMarkProps) {
  const s = sizeMap[size]
  return (
    <div
      data-slot="brand-mark"
      className={cn('inline-flex items-center', s.gap, className)}
      {...props}
    >
      <span
        aria-hidden
        className={cn(
          'relative inline-flex shrink-0 items-center justify-center',
          s.glyph,
        )}
      >
        <img
          src="/brand-mark.png"
          width="36"
          height="36"
          alt=""
          className="size-full object-contain drop-shadow-[0_10px_18px_rgba(124,58,237,0.25)]"
        />
      </span>
      {wordmark ? (
        <span
          className={cn(
            'font-semibold text-foreground',
            s.text,
          )}
        >
          {product}
        </span>
      ) : null}
    </div>
  )
}

export { BrandMark }
